module.exports = __webpack_public_path__ + "img/shanghai.80681513.png";